export default __webpack_public_path__ + "static/media/iran-flag-round-circle-icon.3ba364bb.svg";